import React, { useState } from "react";
import "./services.css";
import { Waypoint } from "react-waypoint";

export const Services = () => {
  const [visible, setVisible] = useState(false);
  const [animatedCards, setAnimatedCards] = useState(0);
  const [cardOnHover, setCardOnHover] = useState();

  const handleWaypointEnter = () => {
    setVisible(true);
  };
  const handleWaypointEnterCards = () => {
    setAnimatedCards((prevCount) => prevCount + 1);
  };

  const cards = [
    {
      icon: <ion-icon name="happy"></ion-icon>,
      title: "Lunes",
      description:
        "10hs a 12hs:Estaremos escuchando los grandes exitos de los ultimos meses!",
    },
    {
      icon: <ion-icon name="happy"></ion-icon>,
      title: "Martes",
      description:
        "10hs a 12hs:Estaremos escuchando los grandes exitos de los ultimos meses!",
    },
    {
      icon: <ion-icon name="happy"></ion-icon>,
      title: "Miercoles",
      description:
        "10hs a 12hs:Estaremos escuchando los grandes exitos de los ultimos meses!",
    },
    {
      icon: <ion-icon name="happy"></ion-icon>,
      title: "Jueves",
      description:
        "10hs a 12hs:Estaremos escuchando los grandes exitos de los ultimos meses!",
    },
    {
      icon: <ion-icon name="happy"></ion-icon>,
      title: "Viernes",
      description:
        "10hs a 12hs:Estaremos escuchando los grandes exitos de los ultimos meses!",
    },
    {
      icon: <ion-icon name="happy"></ion-icon>,
      title: "Sabado y Domingo",
      description:
        "10hs a 12hs:Estaremos escuchando los grandes exitos de los ultimos meses!",
    },
  ].map((card, index) => {
    return (
      <Waypoint onEnter={() => handleWaypointEnterCards()} key={index}>
        <div
          className={
            index < animatedCards
              ? ` h-auto inline-block flex-col bg-white  p-8 ${"card-" + index}`
              : "h-auto inline-block flex-col bg-white   p-8  opacity-0 translate-y-12 transition-opacity transition-100 ease-in-out"
          }
          onMouseEnter={() => setCardOnHover(index)}
          onMouseLeave={() => setCardOnHover(null)}
        >
          <div
            className={`icon-container ${
              cardOnHover === index ? "hovering-bg-icon" : ""
            }`}
          >
            {card.icon}
          </div>

          <h3
            className="font-bold mb-6 pb-6 text-3xl border-b-8 border-gray-200 transition-75 inline-block relative text-black"
            id={cardOnHover === index ? "hovering" : ""}
          >
            {card.title}
          </h3>
          <p className=" max-w-full mb-8 text-xl">{card.description}</p>
          <a
            href=""
            className="read-more mt-8 inline-block text-orange-400 no-underline text-xl flex flex-row items-center"
          >
            Leer más <ion-icon name="arrow-forward" />
          </a>
        </div>
      </Waypoint>
    );
  });

  return (
    <div
      className=" w-full h-auto bg-gray-200 py-20 px-0 flex flex-col items-center"
      id="programacion"
    >
      <Waypoint onEnter={handleWaypointEnter}>
        <div
          className={visible ? "section-header-animation" : "section-header"}
        >
          <h1 className="before-after-title text-bold relative mb-2 text-2xl md:text-3xl lg:text-4xl">
            Programación
          </h1>
          <p className="text-xl w-full text-center sm:w-96 md:text-2xl">
            Acá podés ver nuestra programación completa, los horarios para que
            no te pierdas aquello que te gustaría escuchar!
          </p>
        </div>
      </Waypoint>

      <div className=" w-full h-auto grid grid-cols-1 grid-rows-auto gap-8 sm:grid-cols-2 xl:grid-cols-3 p-8 ">
        {cards}
      </div>
    </div>
  );
};
